<template>
  <modal :title="'Emails'" @close="$emit('close')">
    >
    <template #content>
      <div
        v-if="data != null"
        class="head row m-0 border-bottom p-t-5 p-l-5 p-r-5 p-b-5 align-items-center justify-content-end"
      >
        <div class="col-xs-12 col-sm-auto p-t-5 p-b-5">
          <button
            class="btn btn-info btn-icon waves-effect waves-light p-r-20 m-l-5"
            type="button"
            @click="addPopShow = true"
          >
            <span class="btn-label m-0 p-0"><i class="fa fa-plus"></i></span>
            <span class="p-l-20 p-r-10">Add Email</span>
          </button>
        </div>
      </div>
      <load-area v-if="data == null"></load-area>

      <dataTable
        :name="'CustomerProviderHotelCodes'"
        ref="agGrid"
        :columnDefs="columnDefs"
        :data="data"
        :addContextMenuItem="getContextMenuItems"
        @cellClicked="updatePopShow = $event.data"
        v-if="data != null"
      ></dataTable>
    </template>
  </modal>
  <upsert
    v-if="addPopShow || updatePopShow != null"
    :addId="hotel.Id"
    :setModel="updatePopShow"
    @add="$refs.agGrid.addRow([$event])"
    @update="$refs.agGrid.changeRow('Id', $event)"
    @close="
      addPopShow = false;
      updatePopShow = null;
    "
  ></upsert>
</template>

<script>
import upsert from "./upsert.vue";
export default {
  name: "Emails",
  props: ["hotel"],
  components: { upsert },
  data() {
    return {
      columnDefs: [
        {
          headerName: "Email",
          field: "Email",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          width: 100,
          flex: 1,
        },
      ],
      data: null,
      addPopShow: false,
      updatePopShow: null,
    };
  },
  created() {
    this.$appAxiosAdmin
      .get("Hotels/" + this.hotel.Id + "/Emails")
      .then((response) => {
        this.data = response.data;
      });
  },
  methods: {
    remove(item) {
      this.$swal({
        icon: "question",
        title: "Warning",
        text: "Are you sure you want to delete the " + item.Email + "?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((question) => {
        if (question.isConfirmed) {
          this.$appAxiosAdmin
            .delete(`Hotels/Emails/` + item.Id)
            .then(() => {
              this.$refs.agGrid.removeRow([item]);
              this.$swal({
                icon: "success",
                title: "Success",
                text: "Email deleted successfully.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
            })
            .catch((err) => {
              this.$isError(err);
            });
        }
      });
    },
    getContextMenuItems(params) {
      let result = [
        "copy",
        "export",
        {
          name: "Update",
          icon: "<i class='fas fa-pencil-alt'></i>",
          action: () => {
            this.updatePopShow = params.node.data;
          },
        },
        {
          name: "Remove",
          icon: "<i class='fas fa-trash-alt'></i>",
          action: () => {
            this.remove(params.node.data);
          },
        },
      ];
      return result;
    },
  },
};
</script>

<style></style>
